import moment from "moment";

export const sales_refunds = {
    inputs: [
        { selector: "external_ref_id" },
        { selector: "company_id" },
        { selector: "pz_transaction_ref" },
        { selector: "iin" },
        { selector: "last_four" },
        { selector: "airline_ticket_number" },
        { selector: "receipt_number" },
        { selector: "acquirer_reference_number" }
    ],
    dropDownFields: [
        {
            selector: "merchant_id",
            apiKey: "mid",
            useTypeAheadCollection: false
        },
        {
            selector: "store_id",
            apiKey: "store_id",
            useTypeAheadCollection: true
        },
        {
            selector: "provider",
            apiKey: "provider",
            useTypeAheadCollection: true
        },
        {
            selector: "method",
            apiKey: "method",
            useTypeAheadCollection: true
        },
        {
            selector: "card",
            apiKey: "card",
            useTypeAheadCollection: true
        }
    ],
    dateFields: [
        { selector: "activity_date" },
        { selector: "settle_date" }
    ],
    amountFields: [
        {
            primary: true,
            selector: "purchase-amount",
            label: "Transaction amount",
            pickerRoot: "purchase_",
            dropdown: {
                selector: "purchase_currency",
                apiKey: "currency_alias",
                useTypeAheadCollection: false
            },
            input: {
                selector: "purchase_amount"
            }
        },
        {
            primary: false,
            selector: "stl-amount",
            label: "Settlement amount",
            pickerRoot: "stl_",
            dropdown: {
                selector: "stl_currency",
                apiKey: "currency_alias",
                useTypeAheadCollection: false
            },
            input: {
                selector: "stl_amount"
            }
        }
    ]
};

export const chargebacks = {
    inputs: [
        { selector: "dispute_id" },
        { selector: "company_id" },
        { selector: "pz_transaction_ref" },
        { selector: "iin" },
        { selector: "last_four" },
        { selector: "original_order_or_transaction_id", primary: true }
    ],
    dropDownFields: [
        {
            selector: "merchant_id",
            apiKey: "mid",
            useTypeAheadCollection: false
        },
        {
            selector: "store_id",
            apiKey: "store_id",
            useTypeAheadCollection: true
        },
        {
            selector: "provider",
            apiKey: "provider",
            useTypeAheadCollection: true
        },
        {
            selector: "method",
            apiKey: "method",
            useTypeAheadCollection: true
        },
        {
            selector: "card",
            apiKey: "card",
            useTypeAheadCollection: true
        },
        {
            selector: "reason_code",
            apiKey: "reason_code",
            useTypeAheadCollection: true
        }
    ],
    dateFields: [
        { selector: "activity_date" }
    ],
    amountFields: [
        {
            primary: true,
            selector: "chargeback-amount",
            label: "Chargeback amount",
            pickerRoot: "",
            dropdown: {
                selector: "currency",
                apiKey: "currency_alias",
                useTypeAheadCollection: false
            },
            input: {
                selector: "amount"
            }
        }
    ]
};

export const authorizations = {
    inputs: [
        { selector: "external_ref_id" },
        { selector: "auth_code" },
        { selector: "company_id" },
        { selector: "pz_transaction_ref" },
        { selector: "iin" },
        { selector: "last_four" },
        { selector: "airline_ticket_number" },
        { selector: "receipt_number" },
        { selector: "acquirer_reference_number" },
        { selector: "card_type" }
    ],
    dropDownFields: [
        {
            selector: "merchant_id",
            apiKey: "mid",
            useTypeAheadCollection: false
        },
        {
            selector: "store_id",
            apiKey: "store_id",
            useTypeAheadCollection: true
        },
        {
            selector: "provider",
            apiKey: "provider",
            useTypeAheadCollection: true
        },
        {
            selector: "method",
            apiKey: "method",
            useTypeAheadCollection: true
        },
        {
            selector: "response_type",
            apiKey: "response_type",
            useTypeAheadCollection: true
        },
        {
            selector: "auth_method",
            apiKey: "auth_method",
            useTypeAheadCollection: true
        }
    ],
    dateFields: [
        {
            selector: "activity_date",
            minDate: moment.utc("2019-06-15").endOf("day")
        }
    ],
    amountFields: [
        {
            primary: true,
            selector: "purchase-amount",
            label: "Transaction amount",
            pickerRoot: "",
            dropdown: {
                selector: "currency",
                apiKey: "currency_alias",
                useTypeAheadCollection: false
            },
            input: {
                selector: "amount"
            }
        }
    ]
};
